import React, { useEffect } from "react";
import HeroSection from "../components/StrategicAllies/HeroSection";
import DrStrategic from "../components/StrategicAllies/DrStrategic";
import CorsanoPartner from "../components/StrategicAllies/CorsanoPartner"
import InariPartner from "../components/StrategicAllies/InariPartner"
import FisioPartner from "../components/StrategicAllies/FisioPartner"
import LilyPartner from "../components/StrategicAllies/LilyPartner"

function Home() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <HeroSection />
      <FisioPartner />
      <CorsanoPartner />
      <LilyPartner />
      <InariPartner />
      <DrStrategic />
    </div>
  );
}

export default Home;